import React from "react";

import Editor from './BEmbedCarouselEditor'
import EditorWrapper from '../../EditorWrapper'

import EmbedCarousel from "../../../redesign/components/EmbedCarousel";
import EmptyArticle from "../../common/EmptyArticle";

const BEmbedCarousel = props => {
    let article = EmptyArticle();
    const { settings } = props;
    article.url = settings.url;

    if (settings.embed) {
        article.embed = settings.embed
    }

    return (
        <div className={props.classes} {...props.events}>
            <EditorWrapper {...props} editor={Editor} />
            <EmbedCarousel
                article={article}
                {...props}
            />
        </div>
    );
};


export default BEmbedCarousel;